'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxElementStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  textFree: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};

var defaultProps = {
  textFree: false
};

var checkboxSizeProps = function checkboxSizeProps(_ref) {
  var themeFromProvider = _ref.theme,
      textFree = _ref.textFree;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var size = theme.reactackle.components.checkbox.input.size;


  return '\n    max-width: ' + (textFree ? (0, _reactackleCore.getValueString)(size) : '100%') + ';  \n  ';
};

var CheckboxElementStyled = exports.CheckboxElementStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CheckboxElementStyled'
})(['display:flex;cursor:pointer;', ';'], checkboxSizeProps);

CheckboxElementStyled.displayName = 'CheckboxElementStyled';
CheckboxElementStyled.propTypes = propTypes;
CheckboxElementStyled.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-checkbox/dist/styles/CheckboxElementStyled.js
// module id = 614
// module chunks = 0